import 'react-toggle/style.css';
import React from 'react';
import Toggle from 'react-toggle';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Brands } from '../../common/constants';

const defaultToggle = css`
  .react-toggle--checked .react-toggle-track {
    background-color: ${(props) => props.theme.colours.toggleTrack} !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    border-color: ${(props) => props.theme.colours.toggleTrack} !important;
  }
`;

const wirelessToggle = css`
    .react-toggle-thumb {
      border-color: ${(props) => props.theme.toggle.default.colour} !important;
      box-shadow: ${(props) => props.theme.toggle.default.shadow} !important;
    }
    .react-toggle-track {
      background-color: ${(props) => props.theme.toggle.default.colour} !important;
    }
    .react-toggle--checked .react-toggle-track {
      background-color: ${(props) => props.theme.toggle.checked.track} !important;
    }
    .react-toggle--checked .react-toggle-thumb {
      border-color: ${(props) => props.theme.toggle.checked.track} !important;
    }
`;

const Container = styled.div.attrs({ className: 'ui__toggle' })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: ${(props) => props.theme.whitespace.xs} 0;

  ${(props) => props.brand === Brands.Wireless ? wirelessToggle : defaultToggle }
`;

const ToggleSwitch = ({checked, brand, label, onChange}) => (
  <Container brand={brand}>
    <Toggle
      name={label}
      id={label}
      icons={brand !== Brands.Wireless}
      checked={checked}
      aria-label={label}
      onChange={onChange}
      aria-checked={checked}
      role="checkbox"
    />
  </Container>
)

ToggleSwitch.defaultProps = {
  checked: false,
  label: '',
  onChange: () => {}
};
ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  brand: PropTypes.string
};

export default ToggleSwitch;
